import {Directive, ElementRef, HostListener, AfterViewChecked, Input} from '@angular/core';
import {EditDataService} from "../services/edit-data.service";
import {ToastsManager} from 'ng2-toastr/ng2-toastr';

@Directive({
  selector: '[edit-div]',
  providers: [ToastsManager]
})
export class EditDivDirective implements AfterViewChecked{
  editTitle: any;
  editDescription: any;
  titleEditable: any;
  closeIcon: any;
  descriptionEditable: any;
  /**
   * Review
   * Todo:
   * edit-div - стиль именования, несоответствие названий
   */
  @Input('edit-div') index: number;

  constructor(
    private el: ElementRef,
    public editDataService: EditDataService,
    public toastr: ToastsManager) {
  }

  @HostListener('click') click() {
    let isEditable = this.titleEditable.value === "false" && this.descriptionEditable.value === "false";
    Array.from(document.getElementsByClassName('rules')).forEach(rule => {
      rule.children[3].classList.toggle("border",false);

      this.editTitle.classList.toggle("border", false);
      this.titleEditable.ownerElement.classList.toggle("edit", true);
      rule.children[0].classList.toggle("hidden", isEditable);
      rule.children[1].classList.toggle("hidden", isEditable);

    });
    if (isEditable) {
      this.titleEditable.ownerElement.classList.toggle("edit", true);
      this.el.nativeElement.innerHTML = 'done';
      this.el.nativeElement.style.color = '#2ecd4c';
      this.editTitle.classList.toggle("border", true);
    } else {
      this.titleEditable.ownerElement.classList.toggle("edit", false);
      this.el.nativeElement.innerHTML = 'create';
      this.el.nativeElement.style.color = '#ff9039';
      this.editTitle.classList.toggle("border", false);
      this.editDataService.editData(this.index, this.editTitle.innerText, this.editDescription.innerText);
    }
    this.el.nativeElement.classList.toggle("hidden", false);
    this.closeIcon.classList.toggle("hidden", false);

    this.titleEditable.value = this.titleEditable.value === "false" ? "true" : "false";
    this.descriptionEditable.value = this.descriptionEditable.value === "false" ? "true" : "false";
    /**
     * Review
     * Todo:
     * Убрать ненужные логи
     */
    console.log( this.titleEditable.value);
  }

  ngAfterViewChecked () {
    this.closeIcon = this.el.nativeElement.parentElement.children[1];
    this.editTitle = this.el.nativeElement.parentElement.children[2];
    this.editDescription = this.el.nativeElement.parentElement.children[3];

    this.titleEditable = this.editTitle.attributes.contentEditable;
    this.descriptionEditable = this.editDescription.attributes.contentEditable;
  }

}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/directives/edit.directive.ts